let heroImageRefreshInterval = null;

/**
 * Hero Carousel
 */
if ($('.hero-image-carousel-instance').length > 0) {
    let heroImageCarousel = new Flickity(document.querySelector('.hero-image-carousel-instance'), {
        cellAlign: 'center',
        contain: true,
        autoPlay: window.config.CAROUSELS.HERO_IMAGE_CAROUSEL,
        adaptiveHeight: false,
        pageDots: false,
        pauseAutoPlayOnHover: false,
        draggable: false
    });

    handleCarouselTimerButton();

    let $cellButtonGroup = $('.hero-image-carousel');
    let $cellButtons = $cellButtonGroup.find('.button');

    $cellButtonGroup.on('click', '.button', function (e) {
        e.preventDefault();

        let index = $(this).data('index');

        heroImageCarousel.stopPlayer();

        heroImageCarousel.select(index);
    });

    /**
     * On slide selection we need to activate the stroke effect.
     */
    heroImageCarousel.on('select', function () {
        $cellButtons.filter('.bullet--active').removeClass('bullet--active');
        $cellButtons.eq(heroImageCarousel.selectedIndex).addClass('bullet--active');
        $cellButtons.eq(heroImageCarousel.selectedIndex).find('circle').css('stroke-dashoffset', '70px');
        heroImageCarousel.playPlayer();

        handleCarouselTimerButton();
    });

    function handleCarouselTimerButton() {
        if (heroImageRefreshInterval != null) {
            clearInterval(heroImageRefreshInterval);
        }

        let offset = 70;

        heroImageRefreshInterval = setInterval(function () {
            offset--;
            $cellButtons.eq(heroImageCarousel.selectedIndex).find('circle').css('stroke-dashoffset', offset + 'px');

            if (offset < 1)
                clearInterval(heroImageRefreshInterval);
        }, 70);
    }
}

/**
 * On hero image carousel remove the hidden class on load and replace w/ fade-up-in class
 */
$(window).on('load', function () {
    if ($('.hero-video-carousel-instance').length > 0) {
        $('.hero-image-carousel-instance .carousel-cell.is-selected .carousel-meta').children().addClass('fade-up-in');
    }

    if ($('.vc-hero-projects-carousel-block').length > 0) {
        $('.vc-hero-projects-carousel-block .hero-image-carousel-instance .carousel-meta')
            .removeClass('hidden')
            .addClass('fade-up-in');
    }
});
